var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-stepper-step',_vm._g(_vm._b({},'v-stepper-step',_vm.$props,false),_vm.$listeners),[_c('span',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.title))]),_c('small',[_vm._v(_vm._s(_vm.subtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }